import React, { useContext } from 'react'

import { ExperimentContext } from '@cred/react-experiments/provider'

import { LP_VS_FORM_EXPERIMENT_ID } from 'experiments/vtConfig'
import { getVariation } from 'utils/experiment'

const withSimpleCtaUrlExperiment = (WrappedComponent) => (props) => {
  const { variationMap } = useContext(ExperimentContext)
  const isSimpleCtaUrlExperimentActive = getVariation(variationMap, LP_VS_FORM_EXPERIMENT_ID, 1)

  return (
    <WrappedComponent {...props} isSimpleCtaUrlExperimentActive={isSimpleCtaUrlExperimentActive} />
  )
}

export default withSimpleCtaUrlExperiment
